export default "__VITE_PUBLIC_ASSET__b0ee2e74__"